<!--
 * @Author: Damon
 * @Date: 2020-09-21 10:58:33
 * @LastEditors: Damon
 * @LastEditTime: 2021-09-25 09:06:11
 * @Description: file content
-->
<template >
  <el-button v-if='hasPerms(perms)'
             :size="size"
             :type="type"
             :loading="loading"
             :disabled="!hasPerms(perms)"
             @click="handleClick">
    <template v-if='!link'>
      {{label}}
    </template>
    <router-link v-if='link'
                 :to='linkurl'>
      {{label}}
    </router-link>
  </el-button>
</template>

<script>
import { hasPermission } from '@/utils/auth'
  ;

export default {
  name: 'DButton',
  props: {
    label: { // 按钮显示文本
      type: String,
      default: 'Button',
    },
    size: { // 按钮尺寸
      type: String,
      default: 'mini',
    },
    type: { // 按钮类型
      type: String,
      default: null,
    },
    loading: { // 按钮加载标识
      type: Boolean,
      default: false,
    },
    disabled: { // 按钮是否禁用
      type: Boolean,
      default: false,
    },
    link: {
      type: Boolean,
      default: false,
    },
    linkurl: {
      type: String,
      default: '',
    },
    perms: { // 按钮权限标识，外部使用者传入
      type: String,
      default: null,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    handleClick() {
      // 按钮操作处理函数
      this.$emit('click', {});
    },
    hasPerms(perms) {
      //   return false;
      if (perms !== null && perms !== '') {
        return hasPermission(this.$route.path, perms) && !this.disabled;
      }
      return true;
      // 根据权限标识和外部指示状态进行权限判断
      // return hasPermission(perms) && !this.disabled;
    },
  },
  mounted() {
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Button/DButton.vue